import { render } from "./ProductPurchaseReport.vue?vue&type=template&id=08879d60&scoped=true"
import script from "./ProductPurchaseReport.vue?vue&type=script&lang=js"
export * from "./ProductPurchaseReport.vue?vue&type=script&lang=js"

import "./ProductPurchaseReport.vue?vue&type=style&index=0&id=08879d60&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08879d60"]])

export default __exports__